import React from 'react';
import AppImage from '@/components/ui/AppImage';


interface MediaCoverage {
  outlet: string;
  logo: string;
  logoAlt: string;
  headline: string;
  date: string;
  excerpt: string;
}

interface MediaRecognitionProps {
  coverage: MediaCoverage[];
}

const MediaRecognition: React.FC<MediaRecognitionProps> = ({ coverage }) => {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-headline font-bold text-foreground mb-4">
            Media Recognition
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Global coverage and institutional endorsements
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {coverage.map((item, index) => (
            <div
              key={index}
              className="bg-card p-6 rounded-xl shadow-md border border-border hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="h-16 flex items-center justify-center mb-6 bg-background rounded-lg p-4">
                <AppImage
                  src={item.logo}
                  alt={item.logoAlt}
                  width={120}
                  height={40}
                  className="object-contain"
                />
              </div>
              <h3 className="text-lg font-headline font-bold text-foreground mb-3 line-clamp-2">
                {item.headline}
              </h3>
              <p className="text-sm text-muted-foreground mb-4">{item.date}</p>
              <p className="text-foreground font-body leading-relaxed line-clamp-3">
                {item.excerpt}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-sm font-cta font-bold text-muted-foreground uppercase mb-6">Featured In</p>
          <div className="flex flex-wrap justify-center items-center gap-8">
            {['United Nations', 'African Union', 'World Health Organization', 'UNESCO', 'Peace Research Institute'].map((org, index) => (
              <div key={index} className="px-6 py-3 bg-card rounded-lg border border-border">
                <p className="font-headline font-bold text-foreground">{org}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaRecognition;